import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import GetControls from "../controls/GetControls";
import CloneFlow from "../flows/CloneFlow";
import TestHistorySearch from "../testHistory/TestHistorySearch";

export default function LeftPane() {
  const location = useLocation();

  // Determine what to show based on path
  const getContent = () => {
    if (location.pathname === "/" || location.pathname.includes("/beacons")) {
      return (
        <>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}>
            Control Panel
          </Typography>
          <GetControls />
        </>
      );
    } else if (location.pathname.includes("/devices")) {
      return (
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}>
          Device Management
        </Typography>
      );
    } else if (location.pathname.includes("/flows")) {
      return (
        <>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}>
            Flow Management
          </Typography>
          {location.pathname === "/flows" && <CloneFlow />}
        </>
      );
    } else if (location.pathname.includes("/test-history")) {
      return (
        <>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}>
            Test History
          </Typography>
          <TestHistorySearch />
        </>
      );
    }
    return null;
  };

  return (
    <Box sx={{ p: 0.5, width: "100%" }}>
      {getContent()}
    </Box>
  );
}